import { Route, Routes } from 'react-router';

import PartyTab from './components/PartyTab/PartyTab';

export default function PartyRoutes() {
  return (
    <Routes>
      <Route index element={<PartyTab />} />
    </Routes>
  );
}
